<template>
  <div class="school-user-info">
    <div class="user-info-body">
      <div class="title">账号基本信息</div>
      <div class="info-container">
        <el-image
          style="width: 120px; height: 120px"
          src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
          fit="cover"
        ></el-image>
        <div class="info-desc">
          <p>
            <span>用户编码：{{ userInfo.nick_id }}</span>
          </p>
          <p>
            <span>创建时间：{{ userInfo.created_time }}</span>
          </p>
          <p>
            <span
              >账号到期日：{{
                userInfo.expire_time ? userInfo.expire_time : '-'
              }}</span
            >
          </p>
        </div>
        <el-divider></el-divider>
        <div class="info-desc" style="margin-left: 170px">
          <p>
            <span>用户姓名：{{ userInfo.name }}</span>
          </p>
          <p>
            <span>用户昵称：{{ userInfo.nickname }}</span>
          </p>
          <p>
            <span>性别：{{ userInfo.sex }}</span>
          </p>
          <p>
            <span>账号：{{ userInfo.phone_num }}</span>
          </p>
          <p>
            <span>在职/离职：{{ userInfo.state }}</span>
          </p>
          <p>
            <span>全职/兼职：{{ userInfo.is_full_or_part }}</span>
          </p>
          <p>
            <span>角色：{{ role }}</span>
          </p>
          <p>
            <span
              >学科：{{ base_platform }}<span v-if="mechanism_platform">,</span
              >{{ mechanism_platform }}</span
            >
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="user-info-body">
            <div class="title">任课班级</div>
            <div class="info-container">
                <div>
                    <el-select v-model="classValue" placeholder="请选择">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </div>
                <div style="margin-top: 30px;">
                    <el-table :data="classTableData" border="" align="center" style="width: 100%">
                        <el-table-column prop="name" label="班级"></el-table-column>
                        <el-table-column prop="startOrEndDate" label="起止时间"></el-table-column>
                        <el-table-column prop="teachingPeriod" label="授课时段"></el-table-column>
                        <el-table-column prop="campusName" label="所属校区"></el-table-column>
                        <el-table-column prop="studentNumber" label="学员数"></el-table-column>
                        <el-table-column prop="addClassTime" label="加入班级时间"></el-table-column>
                    </el-table>
                </div>
                <div style="margin-top: 30px;text-align: right;">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        layout="prev, pager, next"
                        :total="1000"
                    ></el-pagination>
                </div>
            </div>
        </div>-->
  </div>
</template>

<script>
import { getUserInfo } from '@/api/user'
export default {
  name: 'school-user-info',
  data() {
    return {
      userInfo: {},
      role: '',
      base_platform: '',
      mechanism_platform: '',
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      getUserInfo({
        nick_id: this.$route.query.id,
      }).then((res) => {
        this.userInfo = res.user_info
        this.role = res.role_list.map((item) => item.name).join('、')
        this.base_platform = res.base_platform
          .map((item) => item.name)
          .join('、')
        this.mechanism_platform = res.mechanism_platform
          .map((item) => item.name)
          .join('、')
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.school-user-info {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  overflow-y: scroll;
  .user-info-body {
    background-color: #ffffff;
    margin: 20px;
    padding: 20px;
    .title {
      font-size: 14px;
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 10px;
    }
    .info-container {
      margin-top: 20px;
      .info-desc {
        font-size: 14px;
        display: inline-block;
        vertical-align: top;
        margin-left: 50px;
        p {
          margin-bottom: 12px;
        }
      }
    }
  }
}
</style>
